import { render } from "./PatientSupply.vue?vue&type=template&id=5eda8aae&ts=true"
import script from "./PatientSupply.ts?vue&type=script&lang=ts&external"
export * from "./PatientSupply.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__